import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Typography,
  Button,
  Divider,
} from '@mui/material';

const ConfirmationDialog = ({
  open,
  onClose,
  onConfirm,
  mode,
  title,
  message,
  confirmText = 'Confirmar',
  cancelText = 'Cancelar',
}) => {
  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="xs">
      <DialogTitle
        sx={{
          backgroundColor: mode === 'confirm' ? 'primary.main' : 'error.main',
          color: 'primary.contrastText',
          fontWeight: 'bold',
          textAlign: 'center',
          py: 2,
        }}
      >
        {title}
      </DialogTitle>
      <Divider />
      <DialogContent sx={{ py: 3 }}>
        <Typography textAlign="center">{message}</Typography>
      </DialogContent>
      <DialogActions sx={{ justifyContent: 'center', py: 2 }}>
        <Button
          onClick={onClose}
          variant="outlined"
          color="primary"
          sx={{ minWidth: 120 }}
        >
          {cancelText}
        </Button>
        <Button
          onClick={onConfirm}
          variant="contained"
          color={mode === 'confirm' ? 'primary' : 'error'}
          sx={{ minWidth: 120 }}
        >
          {confirmText}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ConfirmationDialog;
